<template>
  <div class="main">
    <template v-if="!blankForGM">
      <div class="finish_close_button_container">
        <div class="viewOnly" v-if="viewOnly">disabled</div>
        <div class="offer pointer" @click="getImage">OFFER</div>
        <div class="close pointer" @click="closeBarq">
          <img src="../assets/close.svg" />
        </div>
      </div>
    </template>
    <div id="container">
      <template v-if="isMOS">
        <div class="nominalValue">
          Nominal Value: {{ numberFilter(value) }},-
        </div>
        <div
          v-for="f in currentFrage_Text_Data"
          :key="f"
          class="frage MOS_text"
        >
          <template v-if="f.type == 'p'">
            <span v-html="f.data"> </span>
          </template>
          <img v-if="f.type == 'img'" :src="loadImg(f.data)" :class="f.style" />
        </div>
      </template>
      <template v-else-if="!blankForGM">
        <div class="nominalValue">
          Nominal Value: {{ numberFilter(value) }},-
        </div>
        <template v-if="currentFrage.special">
          <div class="HOM_special">{{ t(barqId + "S") }}</div>
        </template>
        <div
          v-for="(frage, i) in currentFrage_Text_Data"
          :key="frage"
          class="frage"
        >
          <template v-for="(f, a) in frage" :key="f">
            <template v-if="a == 0">
              {{ currentFrage.fragen[i] + ": " }}
            </template>
            <template v-if="f.type == 'p'">
              <span v-html="f.data"> </span>
            </template>
            <img
              v-if="f.type == 'img'"
              :src="loadImg(f.data)"
              :class="f.style"
            />
          </template>
        </div>
      </template>
    </div>
    <div class="CanvasHolderSmall">
      <div class="rect"></div>
      <div class="rect"></div>
    </div>
  </div>
</template>

<script>
import Dict from "../../services/dict_new.js";
import Fragen from "../../fragen.json";

export default {
  name: "BarqAnswers",
  props: {
    isMOS: {
      type: Boolean,
      default: () => false,
    },
    sprache: {
      type: String,
      default: () => "english",
    },
    barqId: {
      type: String,
      default: () => "",
    },
    value: {
      type: Number,
      default: () => 10000,
    },
    lock: {
      type: Boolean,
      default: () => false,
    },
    blankForGM: {
      type: Boolean,
      default: () => false,
    },
  },
  emits: ["closeBarq", "getImage"],
  watch: {
    barqId: function (newVal) {
      // watch it
      this.currentFrage = this.alleAufgaben[newVal];
      // console.log(this.currentFrage);
      for (var f of this.currentFrage.fragen) {
        this.currentFrage_Text_Data.push(this.t(newVal + f));
      }
    },
    lock: function (newVal) {
      this.viewOnly = newVal;
    },
  },
  data() {
    return {
      currentFrage: [],
      currentFrage_Text_Data: [],
      codes: {
        block: [[], []],
        range: [[], []],
        single: [],
      },
      location: "",
      bonus: [],
      alleAufgaben: Fragen,
      fontsize: "font-size=20px",
      viewOnly: this.lock,
    };
  },

  methods: {
    t(word) {
      return Dict(word, this.sprache);
    },
    loadImg(src) {
      let img = "";
      try {
        img = require("../assets/fragen/" + src + ".png");
      } catch (e) {
        console.log("img not found");
      }
      return img;
    },
    closeBarq() {
      this.$emit("closeBarq");
    },
    getImage() {
      this.$emit("getImage");
      // this.$emit("closeBarq");
    },
    //FILTERS
    numberFilter(n) {
      return parseInt(n).toLocaleString("de-DE");
    },
  },
  created() {
    // console.log(this.alleAufgaben);
    // this.currentFrage = this.alleAufgaben.find((el) => el.name == this.barqId);
    if (!this.alleAufgaben[this.barqId]) return;
    // console.log(this.barqId);
    if (this.isMOS) {
      // console.log("isMOS");
      this.currentFrage_Text_Data = this.t(this.barqId);
      // console.log(this.currentFrage_Text_Data);
      return;
    }
    this.currentFrage = this.alleAufgaben[this.barqId];
    // console.log(this.currentFrage);
    for (var f of this.currentFrage.fragen) {
      this.currentFrage_Text_Data.push(this.t(this.barqId + f));
    }
    // console.log(this.currentFrage_Text_Data);
  },
  mounted() {},
};
</script>

<style scoped>
.MOS_text {
  line-height: 30px;
}

.HOM_special {
  font-size: 12px;
  font-style: italic;
  color: var(--barq-orange);
}

.viewOnly {
  width: 60px;
  position: absolute;
  height: 32px;
  color: white;
  background: white;
  z-index: 2;
}

.close,
.send {
  border: 2px solid var(--barq-orange);
  width: 25px;
  height: 25px;
  border-radius: 50%;
  position: relative;
  background: white;
  margin-left: 10px;
}

.offer {
  border: 2px solid var(--barq-orange);
  color: var(--barq-orange);
  line-height: 25px;
  border-radius: 12px;
  font-size: 15px;
}

.close:hover {
  background: var(--barq-orange);
}

.offer:hover {
  color: white;
  background: var(--barq-orange);
}

.close:hover img {
  filter: brightness(10);
}

.close > img {
  width: 25px;
  position: absolute;
  top: calc(50%);
  left: calc(50%);
  transform: translateY(-50%) translateX(-50%);
}

.send:hover {
  background: var(--barq-orange);
}

.send:hover img,
.close:hover img {
  filter: brightness(10);
}

.send > img {
  width: 21px;
  position: absolute;
  top: calc(50% + 1px);
  left: calc(50% - 1px);
  transform: translateY(-50%) translateX(-50%);
}

.finish_close_button_container {
  position: absolute;
  display: flex;
  right: 0px;
  top: -40px;
  z-index: 3;
}

.main {
  border: 6px solid var(--barq-orange);
  border-left: none;
  border-top-right-radius: 70px;
  border-bottom-right-radius: 70px;
  position: relative;
  height: calc(100% - 12px);
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.nominalValue {
  /* margin-bottom: -40px; */
  font-size: 20px;
}

.CanvasHolderSmall {
  display: flex;
  justify-content: space-around;
}

.rect {
  border: 3px dashed var(--barq-orange);
  width: min(13.08vh, 101px);
  height: min(13.08vh, 101px);
  aspect-ratio: 1;
  border-radius: 5px;
  margin: 10px;
}

.frage {
  /* margin: 10px 0; */
}

#container {
  width: 310px;
  padding: 0 10px;
  z-index: 2;
  height: calc(100% - 130px);
  display: flex;
  flex-wrap: wrap;
  align-content: space-around;
  position: relative;
  background: white;
  border-top-right-radius: 66px;
  font-size: 14px;
}

.small {
  height: 1.7em;
  margin: 0 5px;
  vertical-align: middle;
}

.star {
  height: 50px;
  margin: 5px 5px;
  vertical-align: middle;
}

.medium {
  width: 42%;
  margin-left: 50%;
  transform: translateX(-50%);
}

.big {
  width: min(60%, 24.5vh);
  margin-left: 50%;
  transform: translateX(-50%);
}

.big2 {
  width: min(100%, 40vh);
  margin-left: 50%;
  transform: translateX(-50%);
  margin-bottom: 4%;
}

.rechenhilfe {
  margin-top: 10%;
  width: min(90%, 50vh);
}

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

@media only screen and (max-height: 550px) {
  .big2 {
    width: 70%;
    margin-left: 50%;
    transform: translateX(-50%);
  }
}
</style>
